<template>
    <body class="bg-white" id="navigater-header">
        
        <div v-if="!isSmallScreen" class="max-w-7xl mx-auto py-3 px-4 sm:px-6 lg:px-8 mt-[60px]" id="app">
            <CommonHeader></CommonHeader>
            <main>
                <div v-if="NewsList && NewsList.length > 0" class="news_list_box w-5/6 mx-auto">
                    <div class="news_item p-[30px] flex hover:border-gray-800 hover:shadow-[0_0_10px_2px_rgba(0,0,0,0.1)] mx-auto "
                         @click="handleClick(index)"
                         v-for="(item, index) in NewsList" :key="index">
                        <div class="news_item_img_box mb-4 w-[45%] ">
                            <div class="  w-[372px] h-[196px] overflow-hidden">
                                <img class="news_item_img  max-w-[372px] object-cover" :src="item.cover_path" />
                            </div>
                        </div>
                        <div class="flex flex-col justify-between w-[55%]  h-[196px]">
                            <div class="flex news_item_header justify-between items-center  mb-4">
                                <h4 class="news_item_title text-[16px] ">
                                    {{item.title}}
                                </h4>
                                <span class="news_item_date mr-4 " style="color: rgb(153, 153, 153);font-size:14px ">
                                    {{item.realse_at.substring(0, 10)}}
                                </span>
                            </div>
                            <div class="news_item_summery  text-[14px]  mb-4" style="color: rgb(102, 102, 102);">{{item.brief}}</div>
                            <div class="flex news_list_item_ext_line gap-3">
                                <div v-for="tag in item.tags.split(',')" :key="tag" class="news_list_item_group border border-gray-300 rounded ">
                                    <a href="#" target="_blank" class="news_list_item_group_item p-[10px] text-gray-800" style="font-size:12px ;color:#999999">{{tag}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <footer>
                <div class="flex justify-center mt-4">
                    <button @click="goToPage(currentPage-1)"
                            :disabled="currentPage === 1"
                            class="px-2 py-2 mx-1 rounded hover:text-primary disabled:opacity-50 disabled:cursor-not-allowed">
                        上一页
                    </button>

                    <a @click="goToPage(1)" class="mx-1 px-2 py-2 rounded hover:text-primary">1</a>
                    <span v-if="currentPage > 3" class="px-2 py-2 mx-1 rounded hover:text-primary">...</span>
                    <!-- 显示相邻的页码 -->
                    <div class="flex  py-2">
                        <div v-for="page in adjacentPages" :key="page">
                            <a @click="goToPage(page)"
                               :class="['px-2', 'mx-1', 'rounded', {'text-primary': page === currentPage, 'hover:text-primary': page !== currentPage}]">
                                {{ page }}
                            </a>
                        </div>
                    </div>

                    <span v-if="currentPage < totalPages - 2" class="px-2 py-2 mx-1 rounded hover:text-primary">...</span>
                    <a v-if="totalPages>1" @click="goToPage(totalPages)" class="mx-1 px-2 py-2 rounded hover:text-primary">{{ totalPages }}</a>
                    <button :disabled="currentPage === totalPages"
                            @click="goToPage(currentPage + 1)"
                            class="px-2 py-2 mx-1 rounded hover:text-primary disabled:opacity-50 disabled:cursor-not-allowed">
                        下一页
                    </button>
                </div>
            </footer>
        </div>
        <div v-else>
            <div class="w-full mx-auto py-2 px-4 sm:px-4 lg:px-4 mt-[50px]" id="app">
                <main>
                    <CommonHeader></CommonHeader>
                    <div v-if="NewsList  && NewsList.length > 0" class="news_list_box w-full mx-auto">
                        <!-- 新闻列表项 - 改为垂直布局 -->
                        <div class="news_item p-4 flex flex-col hover:shadow-[0_0_5px_1px_rgba(0,0,0,0.1)] mx-auto border-b border-gray-100"
                             @click="handleClick(index)"
                             v-for="(item, index) in NewsList" :key="index">
                            <!-- 图片部分 - 全宽 -->
                            <div class="news_item_img_box w-full mb-3">
                                <div class="w-full h-[180px] overflow-hidden rounded-lg">
                                    <img class="news_item_img w-full h-full object-cover" :src="item.cover_path" />
                                </div>
                            </div>

                            <!-- 内容部分 - 全宽 -->
                            <div class="flex flex-col justify-between w-full">
                                <div class="flex flex-row news_item_header justify-between items-start mb-2">
                                    <h4 class="news_item_title text-[15px] font-medium flex-1 line-clamp-2">
                                        {{item.title}}
                                    </h4>
                                    <span class="news_item_date ml-2 text-gray-400 text-[12px] whitespace-nowrap">
                                        {{item.realse_at.substring(0, 10)}}
                                    </span>
                                </div>

                                <div class="news_item_summery text-[13px] text-gray-600 mb-3 line-clamp-2 flex items-left">
                                    {{item.brief}}
                                </div>

                                <!-- 标签 - 调整为更适合移动端 -->
                                <div class="flex flex-row news_list_item_ext_line flex-wrap gap-2">
                                    <div v-for="tag in item.tags.split(',')" :key="tag"
                                         class="news_list_item_group border border-gray-200 rounded-lg">
                                        <a href="#" target="_blank" class="news_list_item_group_item px-2 py-1 text-gray-500 text-[11px]">
                                            {{tag}}
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div v-if="index < NewsList.length - 1" class="mt-2 border-t border-gray-300  h-3 w-full"></div>
                        </div>
                    </div>
                </main>

                <!-- 分页 - 移动端优化 -->
                <footer class="pb-6">
                    <div class="flex flex-row justify-center items-center mt-4 flex-wrap gap-1">
                        <!-- Previous Button -->
                        <button @click="goToPage(currentPage-1)"
                                :disabled="currentPage === 1"
                                class="px-3 py-1.5 text-sm rounded-lg bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
                            上一页
                        </button>

                        <!-- First Page -->
                        <a @click="goToPage(1)"
                           class="px-3 py-1.5 text-sm rounded-lg bg-gray-100 min-w-[2.25rem] text-center"
                           :class="{'bg-blue-100 text-blue-600': currentPage === 1}">
                            1
                        </a>

                        <!-- Leading Ellipsis -->
                        <span v-if="currentPage > 3" class="px-1 py-1.5 text-sm">...</span>

                        <!-- Adjacent Pages -->
                        <div v-for="page in adjacentPages" :key="page">
                            <a @click="goToPage(page)"
                               class="px-3 py-1.5 text-sm rounded-lg bg-gray-100 min-w-[2.25rem] text-center"
                               :class="{'bg-blue-100 text-blue-600': page === currentPage}">
                                {{ page }}
                            </a>
                        </div>

                        <!-- Trailing Ellipsis -->
                        <span v-if="currentPage < totalPages - 2" class="px-1 py-1.5 text-sm">...</span>

                        <!-- Last Page -->
                        <a v-if="totalPages>1"
                           @click="goToPage(totalPages)"
                           class="px-3 py-1.5 text-sm rounded-lg bg-gray-100 min-w-[2.25rem] text-center"
                           :class="{'bg-blue-100 text-blue-600': currentPage === totalPages}">
                            {{ totalPages }}
                        </a>

                        <!-- Next Button -->
                        <button :disabled="currentPage === totalPages"
                                @click="goToPage(currentPage + 1)"
                                class="px-3 py-1.5 text-sm rounded-lg bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
                            下一页
                        </button>
                    </div>
                </footer>
            </div>
        </div>
    </body>
</template>
<script>
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import CommonHeader from './subassembly/CommonHeader.vue';
export default {
    components: {
        CommonHeader,
    },
    name: 'HomePage',
    metaInfo: {
        title: '识心智能 - 动态',
        meta: [
            {
                name: 'description',
                content: '识心智能官网，各行各业量身定制专属的智能心理健康解决方案，以AI科技的力量促进心理健康事业的创新与繁荣发展'
            },
            {
                name: 'keywords',
                content: '识心智能, 心理健康, 心理健康AI, 心理AI, 健康AI, 心理健康方案, 声音疗愈, 智慧校园, 校园心理, 咨询师AI助手'
            }
        ]
    },

    data() {
        return {
            NewsList: [],
            isLoggedInState: false,
            isUserMenuVisible: false,
            user: {},
            form: {
                dialogFormVisible: false,
                phone: '',
                phonePrefix: '+86',
                verificationCode: '',
                nickname: '',
                birthday: '',
                gender: '',
                invitationCode: '',
                agreement: false,
                phoneError: '',
                verificationCodeError: '',
                nicknameError: '',
                agreementError: '',
                isCountingDown: false,
                countdown: 60,
                verificationButtonText: '获取验证码'
            },
            loginForm: {
                dialogFormVisible: false,
                phonePrefix: '+86',
                phone: '',
                verificationCode: '',
                phoneError: '',
                verificationCodeError: '',
                isCountingDown: false,
                countdown: 60,
                verificationButtonText: '获取验证码'
            },
            registrationMessage: '',
            loginMessage: '',
            dialogWidth: '30%',
            showMenu: false, // 控制导航选项的显示状态

            currentPage: 1,
            totalPages: 10, // 总页数
        };
        },
    computed: {
        adjacentPages() {
            const pages = [];
            for (let i = Math.max(2, this.currentPage - 1); i <= Math.min(this.totalPages - 1, this.currentPage + 1); i++) {
                pages.push(i);
            }
            return pages;
        }
    },
    mounted() {
        this.updateDialogWidth();
        window.addEventListener('resize', this.updateDialogWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateDialogWidth);
    },
    methods: {        
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'  // 平滑滚动
            });
        },
        async goToPage(page) {
            this.currentPage = page;
            await this.getPageList();
            this.scrollToTop();
        },
        gotoHome() {
            this.$router.push({ name: 'HomePage' });
        },
        gotoTeacherAI(){
            this.$router.push({ name: 'TeacherAI' });
        },
        gotoNewsInfoTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        },
        gotoCounselorAI() {
            this.$router.push({ name: 'CounselorAI' });
        },
        scrollToSection(sectionId) {
            this.$router.scrollTo({
                el: `#${sectionId}`,
                behavior: 'smooth'
            });
        },
        updateDialogWidth() {
            if (window.innerWidth <= 1000) {
                this.dialogWidth = '90%';
            } else {
                this.dialogWidth = '30%';
            }
        },
        isLoggedIn() {
            return !!localStorage.getItem('token');
        },
        showUserMenu() {
            this.isUserMenuVisible = true;
        },
        hideUserMenu() {
            this.isUserMenuVisible = false;
        },
        showRegister() {
            this.loginForm.dialogFormVisible = false;
            this.form.dialogFormVisible = true;
        },
        showLogin() {
            this.form.dialogFormVisible = false;
            this.loginForm.dialogFormVisible = true;
        },
        beginTrial() {
            if (this.isLoggedIn()) {
                // 登录成功后路由到 /chat1 页面
                this.$router.push({ name: 'ChatOne' });
            } else {
                this.form.dialogFormVisible = false;
                this.loginForm.dialogFormVisible = true;
            }
        },
        logout() {
            localStorage.removeItem('token');
            this.user = {};
            this.isLoggedInState = false;
            this.$message({
                message: '登出成功',
                type: 'success'
            });
        },
        validatePhone() {
            const phoneRegex = /^[0-9]{11}$/;
            if (!phoneRegex.test(this.form.phone)) {
                this.form.phoneError = '请输入有效的11位手机号';
            } else {
                this.form.phoneError = '';
            }
        },
        validateVerificationCode() {
            if (!this.form.verificationCode) {
                this.form.verificationCodeError = '验证码不能为空';
            } else if (!/^[0-9]{6}$/.test(this.form.verificationCode)) {
                this.form.verificationCodeError = '请输入6位数字验证码';
            } else {
                this.form.verificationCodeError = '';
            }
        },
        validateNickname() {
            if (!this.form.nickname) {
                this.form.nicknameError = '昵称不能为空';
            } else if (this.form.nickname.length > 20) {
                this.form.nicknameError = '昵称长度不能超过20个字符';
            } else {
                this.form.nicknameError = '';
            }
        },
        validateAgreement() {
            if (!this.form.agreement) {
                this.form.agreementError = '请阅读并同意用户协议和隐私政策';
            } else {
                this.form.agreementError = '';
            }
        },
        saveAuthData(response) {
            // 保存 token 和用户信息到 localStorage
            if (response.data.token) {
                localStorage.setItem('token', response.data.token);
            }
        },
        async submitForm() {
            this.validatePhone();
            this.validateVerificationCode();
            this.validateNickname();
            this.validateAgreement();

            if (this.form.phoneError || this.form.verificationCodeError || this.form.nicknameError || this.form.agreementError) {
                return;
            }

            try {
                const payload = {
                    phone: this.form.phone,
                    nickname: this.form.nickname,
                    birthday: this.form.birthday,
                    gender: this.form.gender,
                    verificationCode: this.form.verificationCode
                };
                const response = await axios.post('/api/register', payload, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                this.$message({
                    message: response.data.message,
                    type: response.data.type
                });
                this.registrationMessage = response.data.message;
                this.form.dialogFormVisible = false;
                if (response.data.token) {
                    this.saveAuthData(response);
                    // 查询用户信息
                    await this.checkTokenAndFetchUserInfo();
                }
            } catch (error) {
                console.error('Registration failed:', error);
                this.registrationMessage = 'Registration failed. Please try again.';
            }
        },
        validateLoginPhone() {
            const phoneRegex = /^[0-9]{11}$/;
            if (!phoneRegex.test(this.loginForm.phone)) {
                this.loginForm.phoneError = '请输入有效的11位手机号';
            } else {
                this.loginForm.phoneError = '';
            }
        },
        validateLoginVerificationCode() {
            if (!this.loginForm.verificationCode) {
                this.loginForm.verificationCodeError = '验证码不能为空';
            } else if (!/^[0-9]{6}$/.test(this.loginForm.verificationCode)) {
                this.loginForm.verificationCodeError = '请输入6位数字验证码';
            } else {
                this.loginForm.verificationCodeError = '';
            }
        },
        async submitLoginForm() {
            this.validateLoginPhone();
            this.validateLoginVerificationCode();

            if (this.loginForm.phoneError || this.loginForm.verificationCodeError) {
                return;
            }

            try {
                const payload = {
                    phone: this.loginForm.phone,
                    verificationCode: this.loginForm.verificationCode
                };
                const response = await axios.post('/api/login', payload, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                this.$message({
                    message: response.data.message,
                    type: response.data.type
                });
                console.log('Login successful:', response.data);
                this.loginMessage = response.data.message;
                this.loginForm.dialogFormVisible = false;
                if (response.data.token) {
                    this.saveAuthData(response);
                    // 查询用户信息
                    await this.checkTokenAndFetchUserInfo();
                }
            } catch (error) {
                console.error('Login failed:', error);
                this.loginMessage = 'Login failed. Please try again.';
            }
        },
        async getVerificationCode(formType) {
            const form = this[formType];
            this.validatePhone();
            if (form.phoneError) {
                this.$message({
                    message: form.phoneError,
                    type: 'error'
                });
                return;
            }

            try {
                const response = await axios.post('/api/get_verification_code', {
                    phone: form.phone,
                    type: formType === 'form' ? 'register' : 'login'
                }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                console.log('Verification code sent:', response.data);
                this.$message({
                    message: response.data.message,
                    type: response.data.type
                });
                this.startCountdown(formType);
            } catch (error) {
                console.error('Failed to get verification code:', error);
                this.$message({
                    message: '获取验证码失败，请重试',
                    type: 'error'
                });
            }
        },
        handleClick(index) {
            localStorage.setItem('newsid', this.NewsList[index].id);
            this.$router.push({ name: 'NewsDetail'});
        },
        startCountdown(formType) {
            const form = this[formType];
            form.isCountingDown = true;
            form.countdown = 60;
            form.verificationButtonText = `${form.countdown}s`;
            const interval = setInterval(() => {
                form.countdown -= 1;
                if (form.countdown > 0) {
                    form.verificationButtonText = `${form.countdown}s`;
                } else {
                    clearInterval(interval);
                    form.verificationButtonText = '获取验证码';
                    form.isCountingDown = false;
                }
            }, 1000);
        },
        async checkTokenAndFetchUserInfo() {
            const token = localStorage.getItem('token');
            if (token) {
                try {
                    const decodedToken = jwtDecode(token);
                    const currentTime = Date.now() / 1000; // 当前时间的秒数
                    // const expDate = new Date(decodedToken.exp * 1000).toLocaleString();
                    // const currentDate = new Date(currentTime * 1000).toLocaleString();
                    // console.log('Token decoded.exp:', expDate, 'currentTime:', currentDate);

                    if (decodedToken.exp > currentTime) {
                        // Token 未过期，查询用户信息
                        const response = await axios.get(`/api/users/${decodedToken.user_id}`, {
                            headers: {
                                'Authorization': `Bearer ${token}`
                            }
                        });
                        this.user = response.data;
                        this.isLoggedInState = true;
                    } else {
                        // Token 已过期，清除本地存储
                        localStorage.removeItem('token');
                    }
                } catch (error) {
                    console.error('Token 解析失败或用户信息查询失败:', error);
                    localStorage.removeItem('token');
                }
            }
        },
        async getPageList() {
            try {
                const response = await axios.get(`/api/news/list?page=${this.currentPage}`, {});
                if (response.status == 200) {
                    this.NewsList = response.data.infos;
                    this.totalPages = parseInt((response.data.total + 9)/ 10);
                }
            } catch (error) {
                console.error('Failed to update token:', error);
            }
        },
        async updateToken() {
            const token = localStorage.getItem('token');
            if (token) {
                try {
                    const response = await axios.post('/api/refresh_token', {}, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    const newToken = response.data.token;
                    localStorage.setItem('token', newToken);
                } catch (error) {
                    console.error('Failed to update token:', error);
                }
            }
        },
    },
    created() {
        this.checkTokenAndFetchUserInfo();
        this.updateToken();
        this.goToPage(1);
    }
};
</script>

<style>
    @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css');
    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@400;500;700&display=swap');
    @import url('https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css');

    ul {
        list-style: none; /* 去掉默认的列表样式 */
    }

    body {
        font-family: 'Noto Sans SC', sans-serif;
    }

    .news_item_img_box {
        overflow: hidden; /* 隐藏超出部分，以确保放大时不显示超出区域 */
    }

    .news_item_img {
        transition: transform 0.3s ease; /* 设置放大时的过渡效果 */
    }

    .news_item:hover .news_item_img {
        transform: scale(1.2); /* 鼠标悬停时放大图片 */
    }
    .news_item:hover .news_item_title {
        color: #3b82f6;
    }
</style>
